import { ChangeEventHandler } from 'react'

import { RadioButton, RadioButtonGroup, Tooltip } from '@joor/design-system'

import { LoadValue, LoadValues } from '../../joorPayOrders.types'
import { messages } from 'features/Orders/ListView/constants/messages'

const RADIO_NAME = 'load-orders'

export function OrderLoadFilter({
  onChange,
  disabled,
}: {
  onChange: (value: LoadValue) => void
  disabled: boolean
}) {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange(e.target.value as LoadValue)
  }

  return (
    <RadioButtonGroup className="radio-group" direction="row">
      <RadioButton
        defaultChecked
        id={LoadValues.partial}
        label={messages.loadThreeMonths}
        name={RADIO_NAME}
        value={LoadValues.partial}
        onChange={handleChange}
        disabled={disabled}
      />
      <Tooltip
        content={messages.loadAllTooltip}
        defaultPlacement="right"
        strategy="fixed"
      >
        <RadioButton
          id={LoadValues.all}
          label={messages.loadAllOrders}
          name={RADIO_NAME}
          value={LoadValues.all}
          onChange={handleChange}
          disabled={disabled}
        />
      </Tooltip>
    </RadioButtonGroup>
  )
}
